<template>
  <div>
    <div v-for="[key,value] in Object.entries(data)">
      <v-row>
        <v-col>
          <Input
            :name="key"
            :readonly="readonly"
            :value="value"
            :roles="roles"
            @update="(new_value,new_key) => {update_prop(key,new_value,new_key)}"
            @delete="delete_prop(key)"
          >
            <template v-slot:extra_actions>
              <AddModel
                v-if="!readonly"
                :bp="bp"
                :field="{...value,'id': key}"
                @update="(new_value,new_key) => {update_prop(key,new_value,new_key)}"
                custom_icon="mdi-pencil"
              />
            </template>
          </Input>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col>
        <div>
          <AddModel
            v-if="!readonly"
            :bp="bp"
            @update="new_prop"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>
  
<script>
  import Input from '@/components/bpcreator/inputs/Input';
  import AddModel from '@/components/bpcreator/model/AddModel';
  export default {
    components: {
      Input,
      AddModel,
    },
      
    name: 'Model',
      
    props: {
      bp: {},
      name: {},
      data: {default: () => ({})},
      readonly: Boolean,
      roles: {default: ()=>({})},
    },
      
    data: () => ({
    }),
      
    computed: {
      is_object() {
        return typeof(this.data) == 'object';
      },
    },
      
    mounted() {
    },
      
    methods: {
      update(value) {
        this.$emit('update',value);
      },

      new_prop(new_prop) {
        this.update({...this.data, ...new_prop});
      },

      update_prop(key,value,new_key) {
        let entries = Object.entries(this.data);
        const index_id = entries.findIndex(it => it[0]==key);
        if (new_key && index_id >= 0) {
          entries[index_id] = Object.entries(value).flat();
          this.update(Object.fromEntries(entries));
        } else {
          this.update({...this.data, [key]: value});
        }


      },
      delete_prop(key) {
        let new_obj = this.data;
        delete new_obj[key];
        this.update(new_obj);
      },
    },
  
    watch: {
    },
  }
</script>